import React from 'react';

import { useTranslation } from 'react-i18next';

import {
  Node,
} from '@uncinc/react-drupal-core';

import './style.scss';

const ViewRelatedHelpPages = ({ entities, readMore }) => {
  const { t } = useTranslation();

  if (entities.size > 0) {
    return (
      <div className="View ViewRelatedHelpPages">
        { readMore && (
          <div className="ViewRelatedHelpPages__text">
            <h2>{t('text_paragraph.read_more')}</h2>
          </div>
        )}
        <div className="row">
          {entities.map((entity) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const className = 'ViewRelatedHelpPages__item';
            return (
              <div key={`${uuid}:${langcode}`} className="col-12 col-md-4">
                <div className={className}>
                  <Node
                    id={id}
                    key={`${uuid}:${langcode}`}
                    entity={entity}
                    viewMode="teaser"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default ViewRelatedHelpPages;
